import React, { useState, useEffect } from "react";
import axios from "axios";
import "../styles/FormPopup.css";
import drp from "../images/DRP12.png";
import toast from "react-hot-toast";
import {
  X,
  User,
  Mail,
  Phone,
  MapPin,
  GraduationCap,
  FileQuestion,
  MessageSquare,
  Send,
  Loader2,
} from "lucide-react";

const FormPopup = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    contact: "",
    city: "",
    educationLevel: "",
    inquiryAbout: "",
    message: "",
  });

  useEffect(() => {
    setIsModalVisible(true);
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post("/api/v1/inquiry/basicinquiry", formData);
      toast.success("Inquiry submitted successfully!", {
        duration: 3000,
        position: "top-right",
        icon: "✅",
      });
      setTimeout(() => {
        setIsModalVisible(false);
      }, 1500);
    } catch (error) {
      toast.error("Form submission failed! Please try again.", {
        duration: 3000,
        position: "top-right",
        icon: "❌",
      });
      console.error("Error submitting form:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  if (!isModalVisible) return null;

  return (
    <div className="fp-modal-overlay">
      <div className="fp-modal-content">
        <div className="fp-modal-header">
          <img src={drp} alt="DRP Logo" className="fp-logo" />
          <h2 className="fp-title">Submit Your Inquiry</h2>
          <button className="fp-close-btn" onClick={handleCancel} type="button">
            <X size={24} />
          </button>
        </div>

        <div className="fp-form-container">
          <div className="fp-form">
            <div className="fp-form-row">
              <div className="fp-form-group">
                <label className="fp-label">
                  <User size={18} className="fp-label-icon" />
                  Name*
                </label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Enter your name"
                  required
                  className="fp-input"
                />
              </div>

              <div className="fp-form-group">
                <label className="fp-label">
                  <Mail size={18} className="fp-label-icon" />
                  Email*
                </label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="your.email@example.com"
                  required
                  className="fp-input"
                />
              </div>

              <div className="fp-form-group">
                <label className="fp-label">
                  <Phone size={18} className="fp-label-icon" />
                  Contact*
                </label>
                <input
                  type="text"
                  name="contact"
                  value={formData.contact}
                  onChange={handleChange}
                  placeholder="+91 XXXXX XXXXX"
                  required
                  className="fp-input"
                />
              </div>

              <div className="fp-form-group">
                <label className="fp-label">
                  <MapPin size={18} className="fp-label-icon" />
                  City*
                </label>
                <input
                  type="text"
                  name="city"
                  value={formData.city}
                  onChange={handleChange}
                  placeholder="Your city"
                  required
                  className="fp-input"
                />
              </div>
            </div>

            <div className="fp-form-row">
              <div className="fp-form-group">
                <label className="fp-label">
                  <GraduationCap size={18} className="fp-label-icon" />
                  Education Level
                </label>
                <select
                  name="educationLevel"
                  value={formData.educationLevel}
                  onChange={handleChange}
                  className="fp-select"
                >
                  <option value="">Select education level</option>
                  <option value="High School">High School</option>
                  <option value="Undergraduate">Undergraduate</option>
                  <option value="Postgraduate">Postgraduate</option>
                </select>
              </div>

              <div className="fp-form-group">
                <label className="fp-label">
                  <FileQuestion size={18} className="fp-label-icon" />
                  Inquiry About*
                </label>
                <select
                  name="inquiryAbout"
                  value={formData.inquiryAbout}
                  onChange={handleChange}
                  required
                  className="fp-select"
                >
                  <option value="">Select inquiry type</option>
                  <option value="DRP India & Abroad Education and Recruitment Services">
                    DRP Education & Recruitment
                  </option>
                  <option value="DRP Software Solutions Pvt Ltd">
                    DRP Software Solutions
                  </option>
                  <option value="DRP Computer Education and Training Institute">
                    DRP Computer Education & Training
                  </option>
                </select>
              </div>

              <div className="fp-form-group fp-full-width">
                <label className="fp-label">
                  <MessageSquare size={18} className="fp-label-icon" />
                  Message
                </label>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Tell us more about your inquiry..."
                  className="fp-textarea"
                />
              </div>
            </div>

            <button
              type="button"
              onClick={handleSubmit}
              disabled={loading}
              className="fp-submit-btn"
            >
              {loading ? (
                <>
                  <Loader2 size={20} className="fp-btn-icon fp-spinner" />
                  Submitting...
                </>
              ) : (
                <>
                  <Send size={20} className="fp-btn-icon" />
                  Submit Inquiry
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FormPopup;
